import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSearchRequest,
} from "../../api";

const initialState = {
	results: [],
	getSearchInProgress: false,
	getSearchError: false,
};

export const getCatalogSearch = createAsyncThunk(
  "catalogSearch/getSearch",
  async (_, { rejectWithValue }) => {
	try {
	  const { query } = _;
	  const response = await getSearchRequest({
		query
	  });
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);


export const catalogSearchSlice = createSlice({
  name: "catalogSearch",
  initialState,
  reducers: {
	clearData(state) {
	  state.results = [];
	},
  },
  extraReducers: (builder) => {
	builder
	  .addCase(getCatalogSearch.pending, (state) => {
		state.getSearchInProgress = true;
		state.getSearchError = null;
	  })
	  .addCase(getCatalogSearch.fulfilled, (state, action) => {
		state.results = action.payload;
		state.getSearchInProgress = false;
		state.getSearchError = null;
	  })
	  .addCase(getCatalogSearch.rejected, (state, action) => {
		state.getSearchInProgress = false;
		state.getSearchError = action.payload;
	  })
  },
});

export const { clearData } = catalogSearchSlice.actions;

// this is for configureStore
export default catalogSearchSlice.reducer;
